<div
  (click)="hideModalOnClick()"
  class="reveal-overlay reveal-overlay--modal-confirmation"
  aria-hidden="true"
></div>
<aside tabindex="-1" #modal class="reveal modal-confirmation" role="dialog">
  <h2>{{ title }}</h2>
  <p class="lead">{{ description }}</p>
  <footer class="footer--modal-confirmation flex-container align-justify">
    <button
      #button1
      type="button"
      class="button primary hollow"
      (click)="cancelClicked()"
    >
      <span>{{ cancelText }}</span>
    </button>
    <button
      type="button"
      class="button primary"
      (click)="confirmClicked()"
      #button2
      [disabled]="disableConfirm"
    >
      <span>{{ confirmText }}</span>
    </button>
  </footer>
</aside>
